import { Button } from "primereact/button";
import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as CTA } from "../../assets/CTA.svg";
import { ReactComponent as Upload_icon } from "../../assets/upload_icon.svg";
import { ReactComponent as Vector } from "../../assets/Vector.svg";
import { ReactComponent as Sync_active } from "../../assets/Sync_active.svg";
import MobileView from "./MobileView";
import TextFileReader from "./TestFileReader";
import { CustomButton } from "../CustomButton";

const SourceUpload = ({
  uploadedFile,
  setUploadedFile,
  setUrl,
  url,
  disabled,
}) => {
  const fileInputRef = useRef(null);
  const [URL, setURL] = useState(url || "");
  const [activeView, setActiveView] = useState("file"); // file | url

  const handleDivClick = () => {
    fileInputRef.current.click();
  };

  const handleFileSelect = (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;

    const allowedTypes = ["text/csv", "text/plain", "application/pdf"];
    const maxSize = 1 * 1024 * 1024; // 1MB
    let errorMessages = [];
    let validFiles = [];

    files.forEach((file) => {
      if (file.size > maxSize) {
        errorMessages.push(`${file.name}: File size should not exceed 1MB`);
        return;
      }
      if (!allowedTypes.includes(file.type)) {
        errorMessages.push(`${file.name}: Only CSV, TXT, or PDF files are allowed`);
        return;
      }
      validFiles.push(file);
    });

    if (errorMessages.length) {
      alert(errorMessages.join("\n"));
    }

    if (validFiles.length > 0) {
      setUploadedFile(validFiles);
      setActiveView("file");
    }

    e.target.value = "";
  };

  const handleUrlChange = (e) => {
    setUrl(e?.target?.value);
    setURL(e?.target?.value);
  };

  const clearURL = () => {
    setUrl(null);
    setURL("");
    if (uploadedFile?.length > 0) {
      setActiveView("file");
    }
  };

  const handleSyncClick = () => {
    if (URL) {
      setActiveView("url");
    }
  };

  useEffect(() => {
    if (uploadedFile?.length > 0 && !url) {
      setActiveView("file");
    } else if (url && !uploadedFile?.length) {
      setActiveView("url");
    }
  }, [uploadedFile, url]);

  return (
    <div className="border rounded-md">
      <div className="pt-3">
        <span className="text-lg font-medium">
          <Vector className="mx-1" />
          Provide the data to train your AI bot. Upload a “txt” file or paste a URL.
        </span>
      </div>

      <div className="flex justify-between mt-3" style={{ justifyContent: "space-between" }}>
        {/* Left Side - Upload / URL Input */}
        <div style={{ width: "40%" }}>
          <p className="text-start font-medium text-gray-800">Source 1</p>
          <div
            className="items-center justify-center rounded-lg border-4 border-dashed border-gray-400 px-4 py-10 cursor-pointer"
            onClick={handleDivClick}
          >
            <div className="flex items-center justify-center border border-red-500 p-3 space-x-4">
              <div className="w-1/12 flex justify-center">
                <Upload_icon />
              </div>
              <div className="w-80 text-gray-600 text-sm text-center break-words">
                Browse and choose the files you want to upload from your computer
              </div>
            </div>

            <div
              style={{ display: "flex", justifyContent: "center", alignItems: "center", paddingBottom: "10px" }}
              className={`${disabled ? "disable_container" : ""}`}
            >
              <CTA />
              <input
                type="file"
                accept=".txt"
                multiple
                ref={fileInputRef}
                className="hidden"
                onChange={handleFileSelect}
                disabled={disabled}
              />
            </div>
          </div>

          {uploadedFile?.[0]?.name && (
            <div className="card-container">
              <div className="card-content">
                <span className="card-title">{uploadedFile?.[0]?.name}</span>
              </div>
              <button className="close-btn" onClick={() => setUploadedFile([])}>
                ✖
              </button>
            </div>
          )}

          <div className="divider-container">
            <div className="divider-line"></div>
            <div className="divider-line"></div>
          </div>

          <p className="text-start font-medium text-gray-800">Source 2</p>
          <div className="flex justify-center items-center">
            <input
              type="url"
              className="w-full"
              onChange={handleUrlChange}
              value={URL}
              placeholder="Ex: https://your-domain.com"
              disabled={disabled}
            />
            <Sync_active className="mt-1 mx-1 cursor-pointer" onClick={handleSyncClick} />
          </div>

          {url && (
            <div className="card-container">
              <div className="card-content">
                <span className="card-title">{URL}</span>
              </div>
              <button className="close-btn" onClick={clearURL}>
                ✖
              </button>
            </div>
          )}
        </div>

        {/* Right Side - Viewer */}
        <div style={{ width: "40%" }}>
          {activeView === "url" && url && <MobileView url={url} />}
          {activeView === "file" && uploadedFile?.length > 0 && <TextFileReader files={uploadedFile} />}
        </div>

        {/* Toggle Buttons */}
        {uploadedFile?.length > 0 && url && (
          <div
            className="flex justify-center gap-6 mr-8"
            style={{ position: "absolute", top: "93.5vh", left: "49vw" }}
          >
            <CustomButton
              label=""
              varient="cancel"
              icon="pi pi-arrow-left"
              iconPos="left"
              autofocus
              onClick={() => setActiveView("file")}
            />
            <CustomButton
              label=""
              varient="cancel"
              icon="pi pi-arrow-right"
              iconPos="left"
              autofocus
              onClick={() => setActiveView("url")}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default SourceUpload;
